// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"54":"ecb8efad","585":"36717fc0","839":"a594c4f9","966":"f0bd041e"}[chunkId] + ".chunk.js";
};